import BaseAPI from './base'
/**
 * API xử lý lớp học
 */
class SelfLearningAPI extends BaseAPI {}

export default new SelfLearningAPI('v1/self-learning', 'Course')
